// extracted by mini-css-extract-plugin
module.exports = {"body":"SocialMediaCard_body__2cYa9","social-button":"SocialMediaCard_social-button__3wYNT","image":"SocialMediaCard_image__X81Cz"};